import { render } from "./MEmbeddedButton.vue?vue&type=template&id=b6485b1a&scoped=true"
import script from "./MEmbeddedButton.vue?vue&type=script&lang=js"
export * from "./MEmbeddedButton.vue?vue&type=script&lang=js"

import "./MEmbeddedButton.vue?vue&type=style&index=0&id=b6485b1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6485b1a"]])

export default __exports__